(function (angular) {
    'use strict';

    angular.module('ui.order.newOrder.addressSelector', [])

        .directive('newOrderAddressSelector', function () {
            return {
                restrict: "E",
                templateUrl: 'app/ui/order/newOrderView/newOrderAddressSelector/newOrderAddressSelector.html',
                scope: {
                    selectedCustomerId: "=customerId",
                    selectedAddress: "=deliveryAddress"
                },
                controller: 'newOrderAddressSelectorController'
            };
        })

        .controller('newOrderAddressSelectorController', function ($scope, newOrderAddressService, newOrderListService) {
            angular.extend($scope, {
                onNewButtonClick: onNewButtonClick,
                onCancelButtonClick: onCancelButtonClick,
                onSaveButtonClick: onSaveButtonClick,
                isAddressesListDisabled: isAddressesListDisabled
            });

            $scope.addressEditMode = false;
            $scope.addresses = [];

            initAddressesListOptions();

            $scope.$watch("selectedCustomerId", onCustomerChange);
            $scope.$watch("selectedAddressHashCode", onAddressChange);

            function onCustomerChange() {
                initAddresses();
            }

            function initAddresses() {
                $scope.addresses = [];

                if ($scope.selectedCustomerId) {
                    newOrderAddressService
                        .getAddresses($scope.selectedCustomerId)
                        .then(setAddresses);
                }
            }

            function onAddressChange() {
                $scope.selectedAddress = null;
                if ($scope.selectedAddressHashCode) {
                    $scope.selectedAddress = _.find($scope.addresses, function (address) {
                        return address.hashCode === $scope.selectedAddressHashCode;
                    });
                    if (!$scope.selectedAddress) {
                        $scope.selectedAddressHashCode = 0;
                    }
                }
            }

            function setAddresses(addresses) {
                $scope.addresses = addresses;

                if ($scope.addresses.length) {
                    $scope.selectedAddressHashCode = $scope.addresses[0].hashCode;
                }

                updateAddressesList();
            }

            function onNewButtonClick() {
                $scope.addressEditMode = true;

                $scope.editedAddress = _.clone($scope.selectedAddress);
                $scope.selectedAddress = null;
            }

            function onSaveButtonClick() {
                $scope.selectedAddressHashCode = newOrderAddressService.addAddress($scope.addresses, $scope.editedAddress);
                updateAddressesList();
                onCancelButtonClick();
            }

            function onCancelButtonClick() {
                onAddressChange();
                $scope.addressEditMode = false;
            }

            function isAddressesListDisabled() {
                return $scope.addressEditMode || $scope.addresses.length < 2;
            }

            function initAddressesListOptions() {
                var getAddresses = function () {
                    return $scope.addresses;
                };
                var addressTemplate = '<span>{{dataItem.title}}</span>';
                $scope.addressesListOptions = newOrderListService.getListOptions(getAddresses, addressTemplate, "hashCode");
            }

            function updateAddressesList() {
                var selectedAddressHashCode = $scope.selectedAddressHashCode;
                newOrderListService.updateList($scope.addressesList);
                if ($scope.selectedAddressHashCode !== selectedAddressHashCode) {
                    $scope.selectedAddressHashCode = selectedAddressHashCode;
                }
            }
        })
    ;
})(window.angular);
